// extracted by mini-css-extract-plugin
export default {"areaItemSlider":"graph-slider_areaItemSlider__e6nQM","labelWrapper":"graph-slider_labelWrapper__eV0+Q","sliderWrapper":"graph-slider_sliderWrapper__KcxDl"};